<template>
  <main
    class="mt-10 md:mt-1 flex flex-col-reverse gap-8 items-center md:flex-row md:gap-16 md:justify-center min-h-[65vh] md:min-h-[80vh]">
    <div class="space-y-2 text-center md:text-left px-10">
      <p class="text-amber-200">Hello, I'am</p>
      <h1 class="text-4xl font-bold md:text-5xl text-gray-900 dark:text-white fadein-up accent-text">FEMAS ALFARIDZI</h1>
      <div class="py-2">
        <h1
          class="typewrite min-w-[18rem] md:min-w-[28rem] text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-slate-700 to-amber-500 dark:from-slate-100 dark:to-yellow-500 md:text-2xl fadein-up"
          ref="typewriter">
          <span class="wrap">{{ txt }}</span>
        </h1>
      </div>
      <p class="text-gray-700 dark:text-white pr-4 fade-in-from-left">Welcome to My personal website. <span class="wave">👋🏼</span></p>
      <br>
      <div class="flex flex-wrap items-center justify-center md:justify-start gap-3 md:gap-4 mt-2 fadein-bot fade-500">
        <!-- Download CV Button -->
        <button
          @click="downloadCV"
          class="flex items-center py-2.5 px-5 text-sm font-medium rounded-xl border transition-all duration-300 text-gray-950 dark:text-[#ffdb70] border-[#ffdb70] dark:border-[#ffdb70] bg-[#ffdb70] dark:bg-transparent hover:bg-[#ffcb47] dark:hover:bg-[#ffdb70]/10 focus:outline-none shadow-lg hover:shadow-[#ffdb70]/20 active:scale-95">
          <svg
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-2 w-4 h-4">
            <path fill-rule="evenodd"
              d="M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zm5.845 17.03a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V12a.75.75 0 00-1.5 0v4.19l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3z"
              clip-rule="evenodd"></path>
            <path
              d="M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z">
            </path>
          </svg>Download CV
        </button>

        <!-- Contact Me Button (Mailto Femas Alfaridzi with professional template) -->
        <a
          href="mailto:femasalfaridzi17@gmail.com?subject=Hello%20Femas%20-%20Portfolio%20Inquiry&body=Hi%20Femas%20Alfaridzi%2C%0A%0AI%20visited%20your%20portfolio%20website%20and%20would%20like%20to%20connect%20with%20you.%0A%0A-%20Name%3A%20%0A-%20Purpose%3A%20%0A%0ABest%20regards%2C"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center py-2.5 px-5 text-sm font-semibold rounded-xl border transition-all duration-300 text-gray-950 dark:text-gray-950 border-[#ffdb70] bg-[#ffdb70] hover:bg-[#ffcb47] dark:bg-[#ffdb70] dark:hover:bg-[#ffcb47] focus:outline-none shadow-lg shadow-[#ffdb70]/20 hover:shadow-[#ffdb70]/30 active:scale-95">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-2 w-4 h-4">
            <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
            <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
          </svg>Contact Me
        </a>
      </div>
    </div>
    <div class="flex justify-center md:justify-start fadein-right">
        <img alt="avatar" fetchpriority="high" width="300" height="300" decoding="async" data-nimg="1"
          class="rounded-full border-4 border-amber-200 pict object-cover object-center w-80 h-80" :src="avatarImage">
    </div>
  </main>
</template>

<script>
import profilePicture from '@/assets/pc3.jpeg'

export default {
  name: 'HomeView',
  data() {
    return {
      toRotate: ["Software Engineer", "Information Technology Specialist", 
      "System Analyst", "Enterprise Application Development"],
      period: 2000,
      txt: '',
      loopNum: 0,
      isDeleting: false,
      avatarImage: profilePicture,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tick();
    });
  },
  methods: {
    tick() {
      let typewriter = this.$refs.typewriter;

      if (!typewriter) {
        return;
      }

      let i = this.loopNum % this.toRotate.length;
      let fullTxt = this.toRotate[i];

      this.txt = this.isDeleting ? fullTxt.substring(0, this.txt.length - 1) : fullTxt.substring(0, this.txt.length + 1);
      typewriter.innerHTML = `<span class="wrap">${this.txt}</span>`;

      let that = this;
      let delta = 200 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(() => {
        that.tick();
      }, delta);
    },
    downloadCV() {
      // Metode 1: Download file dari folder public
      const link = document.createElement('a');
      link.href = '/cv/Femas_Alfaridzi_cv.pdf'; // Path file CV di folder public
      link.download = 'Femas_Alfaridzi_cv.pdf'; // Nama file yang akan didownload
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Metode 2 (alternatif): Jika file CV ada di assets
      // import cvFile from '@/assets/cv/Femas_Alfaridzi_CV.pdf'
      // Kemudian gunakan:
      // link.href = cvFile;
    }
  }
}
</script>

<style>
body {
  overflow-y: scroll;
  overflow-x: hidden;
}

.typewrite>.wrap {
  border-right: 0.08em solid #fce0b3;
}

.wave {
  animation-name: wave-animation;
  animation-duration: 2.5s;
  animation-iteration-count: infinite;
  transform-origin: 70% 70%;
  display: inline-block
}

@keyframes wave-animation {
  0% {
    transform: rotate(0deg)
  }

  10% {
    transform: rotate(14deg)
  }

  20% {
    transform: rotate(-8deg)
  }

  30% {
    transform: rotate(14deg)
  }

  40% {
    transform: rotate(-4deg)
  }

  50% {
    transform: rotate(10deg)
  }

  60% {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(0deg)
  }
}

.pict {
  box-shadow: 0px 0px 73px -9px rgba(255, 254, 205, 0.765);
-webkit-box-shadow: 0px 0px 73px -9px rgba(237, 203, 66, 0.889);
-moz-box-shadow: 0px 0px 73px -9px rgb(250, 255, 186);
}

.fadein-up {
  opacity: 0;
  animation-name: fadeInUp;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  animation-delay: 500ms;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fade-in-from-left {
  opacity: 0;
  animation: fadeInLeft 0.5s ease-out forwards;
  animation-delay: 500ms;
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.fadein-right {
  opacity: 0;
  animation: fadeInRight 0.5s ease-out forwards;
  animation-delay: 500ms;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.fadein-bot {
  opacity: 0;
  animation: fadeInBot 0.5s forwards;
}

@keyframes fadeInBot {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadein-1 {
  animation-delay: 200ms;
}
.fadein-2 {
  animation-delay: 400ms;
}
.fadein-3 {
  animation-delay: 600ms;
}
.fade-500 {
  animation-delay: 500ms;
}
</style>